import * as React from "react";
import {
  Columns,
  Column,
  Stack,
  Card,
  CardProps,
  Button,
} from "@origin-digital/ods-core";
import { Text } from "@origin-digital/style-guide";

export interface IProps {
  text: string;
  cta: string;
  icon: React.ReactNode;
  onClick: () => void;
  backgroundColor?: CardProps["backgroundColor"];
  "data-id"?: string;
}

export const CallToActionCard = ({
  text,
  cta,
  icon,
  onClick,
  backgroundColor = "grey50",
  "data-id": dataId,
}: IProps) => {
  return (
    <Card data-id="callToActionCard" backgroundColor={backgroundColor}>
      <Columns space="none">
        <Column width="flex">
          <Stack space={["medium", "large"]} alignX="left">
            <Text>{text}</Text>
            <Button size="small" onClick={onClick} data-id={`${dataId}-button`}>
              {cta}
            </Button>
          </Stack>
        </Column>
        <Column width="content">{icon}</Column>
      </Columns>
    </Card>
  );
};
